import React from "react";
import "./CallToActionSection.css";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const CallToActionSection = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact");
  };

  return (
    <section className="home-cta-section">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        viewport={{ once: true }}
      >
        <h2 className="home-cta-heading">
          Drop your details, we’ll handle the rest.
        </h2>
        <button className="home-cta-button" onClick={handleContactClick}>
          Contact Us
        </button>
      </motion.div>
    </section>
  );
};

export default CallToActionSection;
